<template>
    <div class="home-withdrawal">
        <h1 class="page-title title">{{ $t('withdraw.title.withdraw')}}</h1>
        <div v-if="this.isWithdrawalConfirm">
            <span style="color: red" v-html="$t('withdraw.note3')"></span>
        </div>
        <!-- show success messages -->
        <div class="alert alert-success" v-if="message.successMessage && this.profileState.maskingVerifiedPerRequest" v-html="$t(message.successMessage)"></div>
        <div v-if="message.errorMsgForVerify">
          <div v-if="message.errorMsgForVerify === 'MSG_TRS_NAF_0218'" class="alert alert-danger"
               v-html="$t('MSG_TRS_NAF_0218', { supportLink: supportLink })">
          </div>
          <div v-else
               class="alert alert-danger"
               v-html="$t(message.errorMsgForVerify)">
          </div>
        </div>
        <div class="page-ct">
            <div class="alert alert-success" v-if="this.model.successMessage">{{$t(this.model.successMessage)}}</div>
            <div v-if="this.model.errorMessage">
                <div class="alert alert-danger" v-html="$t(this.model.errorMessage)"></div>
            </div>

            <div class="bank-list withdrawal-background overflow-hidden">
                <div class="row row-narrow fix-flexbox">
                    <!--list bank for web-->
                    <div class="row row-narrow fix-flexbox w-100">
                        <div :class="index === 0 ? 'col-sm-4 hidden-xs fix-flexbox' : '' " v-for="(item, index) in this.listServiceFrom" :key="item.key">
                            <label id="lblFromWithdrawal0" class="btn btn-border-withdrawal btn-block lblFrom" v-if="index === 0">
                                <input type="radio" name="serviceFrom" :value="item.key"
                                       v-model="input['serviceTypeFrom']" :disabled="item.isDisabled"/>{{$t(item.value)}}
                                <div v-if="item.key === '0'" class="text-center">
                                    {{$t("withdrawal.ams.available.amount")}} {{availableAmount | moneyFormat}}
                                    {{$t("withdraw.label.money")}}
                                </div>
                            </label>
                            <i v-if="index === 0" class="fas fa-exchange-alt" style="padding-left: 30px;margin-bottom: 0.5rem"/>
                        </div>

                        <div class="col-sm-8" style="padding-bottom: 0 !important;">
                            <div class="row row-narrow" style="margin-bottom: 0 !important;">
                                <div :class="index >= 1 ? 'col-sm-6 hidden-xs example-icon' : '' " v-for="(item, index) in listServiceFrom" :key="item.key">
                                    <label :id="'lblFromWithdrawal' + item.key" class="btn btn-border-withdrawal btn-block lblFrom" v-if="index >= 1">
                                        <input type="radio" name="serviceFrom" :value="item.key"
                                               v-model="input['serviceTypeFrom']" :disabled="item.isDisabled"/>{{$t(item.value)}}
                                        <div v-if="item.key === '21'" class="text-center">
                                            {{$t("withdrawal.other.available.amount")}}
                                            {{availableAmountNTDFX | moneyFormat}} {{$t("withdraw.label.money")}}
                                        </div>
                                        <div v-if="item.key === '4'" class="text-center">
                                            {{$t("withdrawal.other.available.amount")}}
                                            {{availableAmountBO | moneyFormat}} {{$t("withdraw.label.money")}}
                                        </div>
                                        <div v-if="item.key === '7'" class="text-center">
                                            {{$t("withdrawal.other.available.amount")}}
                                            {{availableAmountSC | moneyFormat}} {{$t('withdraw.label.money')}}
                                        </div>
                                        <div v-if="item.key === '31'" class="text-center">
                                            {{$t("withdrawal.other.available.amount") }}
                                            {{availableAmountCrypt | moneyFormat}} {{$t('withdraw.label.money')}}
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--list bank for mobile-->
                    <div class="col-12 nopadding-right visible-xs col-padding-mobile">
                        <div class="col-12 nopadding-left nopadding-right">
                            <div class="col-5 nopadding-left nopadding-right float-left">
                                <div class="ng-scope example-icon div-mobile-wdrawal" v-for="(item, index) in this.listServiceFrom" :key="item.key">
                                    <label v-if="index === 0" class="btn-border-withdrawal btn-block lblFrom withdrawal-nopadding" :disabled="item.isDisabled"
                                           :class="input['listServiceFrom'] == item.key && !disableRadio[item.key] ? 'active': ''">
                                        <input type="radio" name="serviceFrom" :value="item.key" v-model="input['listServiceFrom']" :disabled="item.isDisabled"/>
                                        <div class="ams-mobile-background">{{$t(item.value)}}</div>
                                        <div class="text-center">
                                            <div class="text-padding pb-3">{{$t("withdrawal.ams.available.amount")}}</div>
                                            <div class="available-amount-text word-break pb-3">{{availableAmount | moneyFormat}} {{$t("withdraw.label.money")}} </div>
                                        </div>
                                    </label>
                                </div>
                            </div>
                            <div class="col-7 nopadding-right col-padding-mobile float-left">
                                <div class="available-amount-text-mobile">{{$t("withdrawal.other.available.amount")}}</div>
                                <div class="col-12 ng-scope example-icon withdrawal-icon-padding" v-for="(item, index) in this.listServiceFrom" :key="item.key">
                                    <div v-if="index > 0">
                                        <label class="label-with-mobile" :disabled="item.isDisabled"
                                               :class="input['listServiceFrom'] == item.key && !disableRadio[item.key] ? 'active': ''">
                                            <span class="withdrawal-inline dl-n" name="serviceFrom" :disabled="item.isDisabled"/>
                                            <input class="dl-n" type="hidden" v-model="input['listServiceFrom']"/>
                                            <div v-if="item.key === '21'" class="text-center">
                                                <div class="col-12 nopadding-left nopadding-right">
                                                    <div class="col-12 nopadding-left nopadding-right">
                                                        <div class="col-5 nopadding-left nopadding-right">
                                                            <div class="withdrawal-text-align float-left">{{$t(item.value)}}:</div>
                                                        </div>
                                                        <div class="col-12 nopadding-left nopadding-right amount-available-mobile">
                                                            {{availableAmountNTDFX | moneyFormat}} {{$t("withdraw.label.money")}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="item.key === '4'" class="text-center">
                                                <div class="col-12 nopadding-left nopadding-right">
                                                    <div class="col-12 nopadding-left nopadding-right">
                                                        <div class="col-5 nopadding-left nopadding-right">
                                                            <div class="withdrawal-text-align float-left">{{$t(item.value)}}:</div>
                                                        </div>
                                                        <div class="col-12 nopadding-left nopadding-right amount-available-mobile">
                                                            {{availableAmountBO | moneyFormat}} {{$t("withdraw.label.money")}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="item.key === '7'" class="text-center">
                                                <div class="col-12 nopadding-left nopadding-right">
                                                    <div class="col-12 nopadding-left nopadding-right">
                                                        <div class="col-5 nopadding-left nopadding-right">
                                                            <div class="withdrawal-text-align float-left">{{$t(item.value)}}:</div>
                                                        </div>
                                                        <div class="col-12 nopadding-left nopadding-right amount-available-mobile">
                                                            {{availableAmountSC | moneyFormat}} {{$t("withdraw.label.money")}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="item.key === '31'" class="text-center">
                                                <div class="col-12 nopadding-left nopadding-right">
                                                    <div class="col-12 nopadding-left nopadding-right">
                                                        <div class="col-5 nopadding-left nopadding-right">
                                                            <div class="withdrawal-text-align float-left">{{$t(item.value)}}:</div>
                                                        </div>
                                                        <div class="col-12 nopadding-left nopadding-right amount-available-mobile">
                                                            {{availableAmountCrypt | moneyFormat}} {{$t("withdraw.label.money")}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-show="!this.profileState.maskingVerifiedPerRequest" style="margin-bottom: 20px;">
                <span class="verify-authentication-note">{{$t('withdraw.verify.passkey.note1')}}</span>
                <verify-authentication screenNameProps="WITHDRAWAL"/>
            </div>

            <div v-if="this.isWithdrawalInput">
                <span>
                    {{$t('withdraw.note1_1')}}<router-link to="transfer">{{$t('withdraw.note1_2')}}</router-link>{{$t('withdraw.note1_3')}}
                </span>
            </div>
            <div v-if="this.isWithdrawalInput">
                <span>{{$t('withdraw.note2')}}</span>
            </div>

            <!-- withdrawal input-->
            <div v-if="this.isWithdrawalInput">
                <div class="section">
                    <h4 class="box-title title">
                        <span>{{$t("withdrawal.title.request")}}</span>
                        <a :href="$t('withdraw.button.help.url')" target="_blank" class="show-popup-help">
                            {{$t('withdraw.button.help')}}
                        </a>
                    </h4>
                    <div class="box-ct">
                        <div class="section-inner">
                            <form class="form-horizontal" name="withdrawal_input_amount" novalidate
                                  @keypress="amountKeyPress($event)">
                                <h5 class="title no-border"><span>{{$t("withdraw.label.withdrawal_amount")}}</span></h5>
                                <div class="form-group">
                                    <div class="col-md-4 margin-custom">
                                        <div class="input-group">
                                            <input
                                                type="text"
                                                class="form-control input-lg moneyMask"
                                                id="moneyMask"
                                                required
                                                :placeholder="$t('withdrawal.placeholder.amount')"
                                                @blur="amountBlurEvent($event)"
                                                @keydown="amountKeyDown($event)"
                                                @keyup="amountKeyUp($event)"
                                                @change="enabledDirtyFlag()"
                                                @input="removeJapaneseCharacters($event)"
                                                v-model="withdrawalAmount"
                                                name="amount"
                                                :disabled="!this.profileState.maskingVerifiedPerRequest">
                                            <span class="input-group-addon currency-addon" style="padding: 10px 12px">
                                                {{$t("withdraw.label.money")}}
                                            </span>
                                        </div>

                                        <div v-if="(!$v.withdrawalAmount.required || !$v.withdrawalAmount.inputAmount) && dirtyFlag && flagCheck" class="error-messages ng-active">
                                            <div v-if="!$v.withdrawalAmount.required">
                                                {{$t("withdraw.error.require")}}
                                            </div>
                                            <div v-if="!$v.withdrawalAmount.inputAmount">
                                                {{$t("withdraw.error.format")}}
                                            </div>
                                        </div>
                                        <div v-if="isWithdrawalAmountOverAvailableAmount" class="error-messages ng-active" v-html="$t('MSG_TRS_NAF_0212')"></div>
                                    </div>
                                </div>
                                <h5 class="title no-border"><span>{{$t("withdraw.bank.info")}}</span></h5>

                                <div class="page-meta" v-if="bankNote !== ''">
                                    <div class="box-ct">{{$t(bankNote)}}</div>
                                </div>
                                <div class="page-meta" v-if="noBankMsg !== ''">
                                    <div class="box-ct">{{$t(noBankMsg)}}</div>
                                </div>
                                <div class="accounts-list">
                                    <div v-if="noBankMsg === ''">
                                        <div v-for="bank in this.banks" :key="bank.bankCode">
                                            <div class="box">
                                                <table class="table table-striped table-noborder table-font-sm">
                                                    <tbody>
                                                    <tr>
                                                        <td width="30%">{{$t("withdraw.label.bank_name")}}</td>
                                                        <td width="70%"><strong>{{bank.bankName}}</strong></td>
                                                    </tr>
                                                    <tr>
                                                        <td>{{$t("withdraw.label.branch_name")}}</td>
                                                        <td><strong>{{bank.branchName}}</strong></td>
                                                    </tr>
                                                    <tr>
                                                        <td>{{$t("withdraw.label.account_type")}}</td>
                                                        <td>
                                                            <strong v-for="item in mapAccountType" :key="item.key">
                                                                <div v-if="item.key === bank.bankAccClass.toString()">
                                                                    {{$t(item.value)}}
                                                                </div>
                                                            </strong>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>{{$t("withdraw.label.account_number")}}</td>
                                                        <td><strong>{{bank.accountNo}}</strong></td>
                                                    </tr>
                                                    <tr>
                                                        <td>{{$t("withdraw.label.account_name")}}</td>
                                                        <td><strong>{{bank.accountNameKana}}</strong></td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="action" v-if="!hideUpdateBankBtn">
                                        <router-link :to="{ name: !this.profileState.maskingVerifiedPerRequest ? '' : 'bankAccount'}">
                                            <button class="btn btn-primary btn-lg p-0 position-relative"
                                                    :class="{'withdrawal-btn' : !this.profileState.maskingVerifiedPerRequest}"
                                                    id="btn-add-bank"
                                                    :disabled="!this.profileState.maskingVerifiedPerRequest">
                                                <span class="d-block btn-lg w-100">
                                                  {{$t("withdraw.button.new_payment")}}
                                                </span>
                                            </button>
                                        </router-link>
                                    </div>
                                    <br/>
                                    <div class="text-left" v-if="!hideWithdrawBtn">
                                        <button class="btn btn-success btn-lg p-0 position-relative"
                                                :class="{'withdrawal-execute-btn' : !this.profileState.maskingVerifiedPerRequest}"
                                                id="btn-withdraw-confirm"
                                                @click.prevent="requestWithdrawalConfirm()"
                                                :disabled="!this.profileState.maskingVerifiedPerRequest">
                                            <span class="d-block btn-lg w-100">
                                                {{$t("withdraw.button.request.execute")}}
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                            <hr class="border-light">
                        </div>
                    </div>
                    <div class="page-meta">
                        <div class="box-ct">{{$t("withdraw.note.3")}}</div>
                        <div class="box-ct">{{$t("withdraw.note", {min: Number(this.withdrawAmount['min']).toLocaleString("ja")})}}</div>
                        <div class="box-ct">{{$t("withdraw.note.2")}}</div>
                        <div class="box-ct">{{$t("withdraw.note.4")}}</div>
                        <div class="box-ct">{{$t("withdraw.note.5")}}</div>
                    </div>
                </div>
                <div class="section">
                    <h4 class="box-title title"><span>{{$t("withdraw.table.name")}}</span></h4>
                    <div class="box-ct">

                        <div class="table-responsive">
                            <table class="table table-striped table-hover table-bordered table-font-sm">
                                <thead>
                                <tr>
                                    <th class="text-center">{{$t("withdraw.header.withdrawal_number")}}</th>
                                    <th class="text-center">{{$t("withdraw.header.date_time")}}</th>
                                    <th class="text-center">{{$t("withdraw.header.amount")}}</th>
                                    <th class="text-center">{{$t("withdraw.header.status")}}</th>
                                    <th class="text-center">{{$t("withdraw.header.cancel")}}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr class="alert" v-for="withdrawalHistory in listWithdrawalHistory" :key="withdrawalHistory.key">
                                    <td class="text-center">{{withdrawalHistory.withdrawalNumber}}</td>
                                    <td class="text-center datetime-column">{{withdrawalHistory.dateTime | formatDate("YYYY-MM-DD HH:mm:ss", "YYYY/MM/DD HH:mm:ss")}}
                                    </td>
                                    <td class="text-right money-column">
                                        {{withdrawalHistory.amount | moneyFormat}}
                                        <span class="yen"> {{$t("currency.japanese.yen")}}</span>
                                    </td>
                                    <td class="text-center">
                                        <div v-if="withdrawalHistory.status === 5"> {{$t("withdraw.requesting")}}</div>
                                        <div v-if="withdrawalHistory.status === 6 || withdrawalHistory.status === 2">
                                            {{$t("withdraw.inprogress")}}
                                        </div>
                                    <td class="text-center" v-if="withdrawalHistory.status === 5">
                                        <a href="javascript:void(0)" class="btn btn-xs btn-danger"
                                           @click="cancelWithdrawal(withdrawalHistory.withdrawalNumber)">
                                            {{$t("withdraw.header.cancel")}}
                                        </a>
                                    </td>
                                    <td class="text-center" v-if="withdrawalHistory.status !== 5">-</td>
                                </tr>
                                <tr>
                                    <td colspan="5" v-if="infoMessage != null" class="nodata">
                                        {{$t(infoMessage)}}
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <nav class="text-center" v-if="this.listWithdrawalHistory != null && this.listWithdrawalHistory !== undefined">
                            <pagination
                                :total-pages="totalPage"
                                :total="totalItems"
                                :per-page="offset"
                                :current-page="currentPage"
                                @pagechanged="onPageChange"
                                @pageJump="onPageJump"
                                :previousText="$t('navigation.bt.previous')"
                                :nextText="$t('navigation.bt.next')"
                                :firstText="$t('navigation.bt.first')"
                                :lastText="$t('navigation.bt.last')"
                            ></pagination>
                        </nav>
                    </div>
                </div>
            </div>

            <!-- withdrawal form confirm -->
            <form class="form-horizontal" v-if="this.isWithdrawalConfirm">
                <div class="section">
                    <div class="box-ct">
                        <h4 class="box-title title"><span>{{$t("withdrawal.title.confirm")}}</span></h4>
                        <div class="section-inner">
                            <div class="row">
                                <div class="col-sm-6">
                                    <table class="table table-noborder table-hover table-striped respect table-font-sm">
                                        <tbody>
                                        <tr>
                                            <td width="50%">{{$t("withdraw.label.method")}}</td>
                                            <td width="50%">{{$t("withdraw.label.bank_wire")}}</td>
                                        </tr>
                                        <tr>
                                            <td>{{$t("withdraw.label.withdrawal_fee")}}</td>
                                            <td>{{this.withdrawalFee | moneyFormat}} {{$t("withdraw.label.money")}}</td>
                                        </tr>
                                        <tr>
                                            <td>{{$t("withdraw.label.receipt_amount")}}</td>
                                            <td>{{this.withdrawalReceived | moneyFormat}} {{$t("withdraw.label.money")}}</td>
                                        </tr>
                                        <tr>
                                            <td>{{$t("withdraw.label.bank_name")}}</td>
                                            <td>{{this.selectedBank.bankName}}</td>
                                        </tr>
                                        <tr>
                                            <td>{{$t("withdraw.label.branch_name")}}</td>
                                            <td>{{this.selectedBank.branchName}}</td>
                                        </tr>
                                        <tr>
                                            <td>{{$t("withdraw.label.account_number")}}</td>
                                            <td> {{this.selectedBank.accountNo}}</td>
                                        </tr>
                                        <tr>
                                            <td>{{$t("withdraw.label.account_name")}}</td>
                                            <td>{{this.selectedBank.accountNameKana}}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div>
                                    <span class="warning-messages" v-html="$t('withdrawal.warning.message')"></span>
                                </div>
                            </div>
                            <button type="submit" class="btn btn-success btn-padding-lg btn-lg mr-1"
                                    :disabled="disableButtonConfirm" @click.prevent="confirmWithdrawal()" >{{$t("withdraw.label.confirm")}}
                            </button>
                            <button type="button" class="btn btn-default btn-padding-lg btn-lg ml-1" @click.prevent="backToInput()">
                                {{$t("withdraw.label.back")}}
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>

    </div>
</template>

<script>
    import {createNamespacedHelpers} from "vuex";
    import Vue from "vue";
    import Pagination from "@/components/base/Pagination.vue";
    import ModalPlugin from "@/common/plugins/ModalPlugin.js";
    import {required} from "vuelidate/lib/validators";
    import {inputAmount} from '@/common/helpers/validation';
    import IConstants from "@/common/constants/IConstants.js";
    import {GET_HEADER_INFO, MENU_HOME, SET_ACTIVE_TAB_ID} from '@/store/modules/header/type';
    import offModalEvent from "@/common/mixins/offModalEvent";
    import {INPUT_NUMBER_ALLOW_KEY_CODE} from "@/common/constants";
    import VerifyAuthentication from "@/common/mixins/VerifyAuthentication";
    import Config from "@/services/Config";

    const {mapGetters: mapHeaderGetters, mapActions: mapHeaderActions} = createNamespacedHelpers("header");
    const {mapState: mapProfileState, mapMutations: mapProfileMutations} = createNamespacedHelpers("editProfile");
    const {mapMutations: mapNewsMutations} = createNamespacedHelpers("news");

export default {
    comments: {},
    components: {Pagination, VerifyAuthentication},
    mixins: [offModalEvent],
    data() {
        return {
            SERVICE_NAME: "withdrawal",
            mapAccountType: this.IConstants.getMapAccountType(),
            withdrawAmount: [],
            minWithdrawAmount: null,
            availableAmount: 0,
            availableAmountNTDFX: 0,
            availableAmountBO: 0,
            availableAmountSC: 0,
            availableAmountCrypt: 0,
            banks: [],
            selectedBank: {},
            verifyBankStatus: IConstants.VERIFY_BANK_STATUS.NO_AVAILABLE,
            bankStatus: IConstants.BANK_STATUS.NO_AVAILABLE,
            hideWithdrawBtn: false,
            hideUpdateBankBtn: false,
            withdrawalHistories: null,
            listWithdrawalHistory: null,
            infoMessage: null,
            totalPage: 0,
            currentPage: 1,
            totalItems: 0,
            offset: 0,
            noBankMsg: null,
            bankNote: '',
            model: {
                successMessage: null,
                errorMessage: null
            },
            input: {
                "serviceTypeFrom": 0,
            },
            listServiceFrom: null,
            isWithdrawalInput: true,
            isWithdrawalConfirm: false,
            withdrawalAmount: null,
            flagCheck: false,
            dirtyFlag: false,
            withdrawalFee: null,
            withdrawalReceived: null,
            MODE_WITHDRAWAL_INPUT: 1,
            MODE_WITHDRAWAL_CONFIRM: 2,
            isConfirmTransfer: false,
            wid: null,
            disableButtonConfirm: false,
            message: {
                errorMessage: null,
                successMessage: null,
                errorMsgForVerify: null
            },
            isWithdrawalAmountOverAvailableAmount: false,
            supportLink: Config.getRegisterPasskeySupportLink()
        }
    },
    validations: {
        withdrawalAmount: {
            required,
            inputAmount,
        }
    },
    computed: {
        ...mapHeaderGetters(["linksAppList"]),
        ...mapProfileState({
            profileState: state => state,
        }),
    },
    watch: {
    },
    async created() {
        this[SET_ACTIVE_TAB_ID](MENU_HOME);
        this[GET_HEADER_INFO]();
        await this.init();
    },
    mounted() {
        this.getModalConfirmResult();
        this.listenEvents()
    },
    beforeDestroy() {
        this.unListenEvents()
    },
    destroyed() {
        this.offEventName(this.IConstants.EVENT_NAME.CLOSE_MODAL_CONFIRM + this.IConstants.E_CONFIRM_SCREEN.WITHDRAWAL_CANCEL);
    },
    methods: {
      ...mapProfileMutations(['assignProfileState']),
      ...mapHeaderActions([
            SET_ACTIVE_TAB_ID,
            GET_HEADER_INFO
        ]),
        ...mapNewsMutations([
            'updateFields'
        ]),
        async init() {
            // get success message after register withdrawal account screen
            if (this.$route.params.changePaymentInfor) {
                this.model.successMessage = this.$route.params.changePaymentInfor;
                this.message.successMessage = null;
                this.$route.params.changePaymentInfor = null;
            }
            await this.getListServiceFrom();
            await this.getMinMaxWithdrawAmount();
            await this.getCurrentPageWithdrawalList();
            await this.initScreen();
        },
        getListServiceFrom() {
            this.listServiceFrom = this.IConstants.getListServiceTypeTransfer();
        },
        async getMinMaxWithdrawAmount() {
            await this.$service.getService(this.SERVICE_NAME).index().then((res) => {
              this.$modal.reAssignProfileStateEvent({
                authInfo: res.authenticateModel,
                screenName: IConstants.SCREEN_NAME.WITHDRAWAL
              });
              if (res.inputInfo) {
                    const input = res.inputInfo;
                    const minWithdrawAmount = this.IConstants.COUNTING_JAPAN_CURRENCY[input.minWithdrawAmount];
                    const maxWithdrawAmount = this.IConstants.COUNTING_JAPAN_CURRENCY[input.maxWithdrawAmount];
                    if (minWithdrawAmount) {
                        this.withdrawAmount['min'] = minWithdrawAmount;
                    } else {
                        this.withdrawAmount['min'] = this.$options.filters.numberFormat(input.minWithdrawAmount, 0);
                    }
                    if (maxWithdrawAmount) {
                        this.withdrawAmount['max'] = maxWithdrawAmount;
                    } else {
                        this.withdrawAmount['max'] = this.$options.filters.numberFormat(input.maxWithdrawAmount, 0);
                    }
                    this.minWithdrawAmount = {
                        min: this.$options.filters.numberFormat(input.minWithdrawAmount, 0)
                    };
                    this.availableAmount = input.availableAmount;
                    this.availableAmountNTDFX = input.availableAmountNTDFX;
                    this.availableAmountBO = input.availableAmountBO;
                    this.availableAmountSC = input.availableAmountSC;
                    this.availableAmountCrypt = input.availableAmountCrypt;
                    this.banks = input.listCustomerBankInfo == null ? [] : [input.listCustomerBankInfo[0]];
                    if (input.listCustomerBankInfo[0].bankName != null && typeof input.listCustomerBankInfo[0].bankName != "undefined") {
                        this.banks = [input.listCustomerBankInfo[0]];
                    } else {
                        this.banks = [];
                    }
                    this.selectedBank = this.banks[0];
                    this.verifyBankStatus = input.listCustomerBankInfo[0].verifyBankStatus;
                    this.bankStatus = input.listCustomerBankInfo[0].bankStatus;
                    if (this.banks.length === 0) {
                        this.hideWithdrawBtn = true;
                        this.hideUpdateBankBtn = false;
                    }
                }
            })
        },
        async getCurrentPageWithdrawalList() {
            await this.$service.getService(this.SERVICE_NAME).getWithdrawalHistory(this.currentPage).then((result) => {
                this.withdrawalHistories = result.listWithdrawalInfo;
                this.infoMessage = result.infoMessage;

                // reset default
                this.totalItems = 0;
                this.offset = 0;
                this.totalPage = 0;
                this.listWithdrawalHistory = null;

                if (this.withdrawalHistories != null) {
                    this.totalItems = result.pagingInfo.total;
                    this.offset = result.pagingInfo.offset;
                    this.totalPage = result.pagingInfo.totalPage;
                    this.listWithdrawalHistory = this.withdrawalHistories;
                }
            });
        },
        initScreen() {
            let withdrawalRequestCount = 0;
            this.noBankMsg = '';
            if (this.withdrawalHistories != null) {
                for (let i = 0; i < this.withdrawalHistories.length; i++) {
                    if (this.withdrawalHistories[i].status === 5 || this.withdrawalHistories[i].status === 6) {
                        withdrawalRequestCount++;
                    }
                }
            }

            switch (true) {
                case this.bankStatus.toString() === this.IConstants.BANK_STATUS.DEFAULT_BANK_STATUS:
                    this.hideWithdrawBtn = true;
                    this.hideUpdateBankBtn = false;
                    this.bankNote = '';
                    this.noBankMsg = 'MSG_NO_BANK';
                    break;
                case this.bankStatus.toString() === this.IConstants.BANK_STATUS.REJECTED
                && this.verifyBankStatus.toString() === this.IConstants.VERIFY_BANK_STATUS.DEFAULT_VERIFY_BANK_STATUS:
                    this.hideWithdrawBtn = true;
                    this.hideUpdateBankBtn = false;
                    this.bankNote = '';
                    break;
                case this.bankStatus.toString() === this.IConstants.BANK_STATUS.WAITING:
                case this.bankStatus.toString() === this.IConstants.BANK_STATUS.RECHECKING:
                    this.hideWithdrawBtn = true;
                    this.hideUpdateBankBtn = true;
                    this.bankNote = "bank.account.note.text2";
                    break;
                case this.bankStatus.toString() === this.IConstants.BANK_STATUS.APPROVED:
                case this.bankStatus.toString() === this.IConstants.BANK_STATUS.REJECTED
                && this.verifyBankStatus.toString() === this.IConstants.VERIFY_BANK_STATUS.VERIFIED:
                    this.hideWithdrawBtn = false;
                    this.hideUpdateBankBtn = false;
                    this.bankNote = '';
                    break;
            }

            if (withdrawalRequestCount > 0) {
                this.hideUpdateBankBtn = true;
                this.bankNote = "bank.account.note.text1";
            }
            if (this.amount !== undefined) {
                this.withdrawalAmount = this.amount;
            }
        },
        onPageChange(page) {
            this.currentPage = page;
            this.getCurrentPageWithdrawalList();
        },
        onPageJump(page, previous, next, maxVisibleButtons) {
            this.currentPage = this.ServiceUtils.getCurrentPageOnPageJump(page, previous, next, maxVisibleButtons);
            this.getCurrentPageWithdrawalList();
        },
        amountKeyPress: function (e) {
            let isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
            if (isIOS) {
                let keyCode = e.keyCode || e.charCode;
                let charCode = e.charCode;
                let isArrow = (charCode == 0 && keyCode >= 37 && keyCode <= 40);
                let isSpecialCharacter = ((keyCode == 8) || (keyCode == 9) || (keyCode == 127)) || isArrow; // backspace, tab, delete
                let isNumber = (keyCode >= 48 && keyCode <= 57);  // numbers
                if (isNumber || isSpecialCharacter || keyCode == 44 || keyCode == 46) { // 44: comma, 46: dot
                    return true;
                } else {
                    e.preventDefault();
                    return false;
                }
            }
            const charCode = (e.which) ? e.which : e.keyCode;
            if (!charCode || charCode == 13) {
                e.preventDefault();
                this.requestWithdrawalConfirm();
            }
        },
        amountBlurEvent: function () {
            this.withdrawalAmount = Vue.filter("formatAmount")(this.withdrawalAmount, 15);
            this.flagCheck = !this.withdrawalAmount;
        },
        amountKeyUp(e) {
            let amount = e.target.value;
            let charCode = e.keyCode || e.which;
            const regexNotAllowSpecialCharacters = /[^\d,.]/g;

            amount = amount.replace(regexNotAllowSpecialCharacters,"");

            // Default keycode for android is 0 or 299
            if (charCode === 0 || charCode === 229) {
                charCode = this.getKeyCode(amount);
            }

            if (!INPUT_NUMBER_ALLOW_KEY_CODE.includes(charCode)) {
                e.target.value = amount.replace(/^[0-9,.]/, '');
            }

            const MAX_LENGTH = 19;
            if (amount && amount.length >= MAX_LENGTH) {
                this.flagCheck = true;
                amount = amount.replace(regexNotAllowSpecialCharacters,"");
                e.target.value = amount.substr(0, MAX_LENGTH);
                return false;
            } else {
                this.flagCheck = false;
            }

            e.target.value = amount.replace(regexNotAllowSpecialCharacters, '');
            return false;
        },
        amountKeyDown: function (e) {
            let allowInputAfterSelected = window.getSelection().toString() !== '';
            const charCode = (e.which) ? e.which : e.keyCode;
            if(!INPUT_NUMBER_ALLOW_KEY_CODE.includes(charCode) || e.shiftKey){
                e.preventDefault();
                return false;
            }
            const val = this.withdrawalAmount;
            if (!allowInputAfterSelected && val && val.length >= 19 && !(charCode == 37 || charCode == 38 || charCode == 39 || charCode == 40 || charCode == 8 || charCode == 46 || charCode == 116)) {
                this.flagCheck = true;
                e.preventDefault();
                return false;
            } else {
                this.flagCheck = false;
            }
        },
        removeJapaneseCharacters(e) {
            let amount = e.target.value;
            const MAX_LENGTH = 19;
            const regexNotAllowSpecialCharacters = /[^\d,.]/g;
            e.target.value = amount.replace(regexNotAllowSpecialCharacters, '');

            if (amount && amount.length >= MAX_LENGTH) {
                amount = amount.replace(regexNotAllowSpecialCharacters,"");
                e.target.value = amount.substr(0, MAX_LENGTH);
                return false;
            }
        },
        getKeyCode(str) {
            return str.charCodeAt(str.length - 1);
        },
        enabledDirtyFlag() {
            this.dirtyFlag = true;
            if (this.isWithdrawalAmountOverAvailableAmount) {
                this.isWithdrawalAmountOverAvailableAmount = false;
            }
        },
        setMode: function setMode(mode) {
            if (mode === this.MODE_WITHDRAWAL_INPUT) {
                this.setHideShow(true, false)
            } else if (mode === this.MODE_WITHDRAWAL_CONFIRM) {
                this.setHideShow(false, true);
            }
        },
        setHideShow: function setHideShow(isInput, isConfirm) {
            this.isWithdrawalInput = isInput;
            this.isWithdrawalConfirm = isConfirm;
        },

        requestWithdrawalConfirm: function () {
          if (!this.profileState.maskingVerifiedPerRequest) return;

            this.dirtyFlag = true;
            this.isWithdrawalAmountOverAvailableAmount = false;
            if (typeof this.withdrawalAmount === "undefined") {
                this.flagCheck = true;
            } else {
                this.flagCheck = false;
                this.model.errorMessage = null;
                this.model.successMessage = null;
                const configs = new FormData();
                configs.append("inputInfo.amount", this.withdrawalAmount ? Vue.filter("formatAmount")(this.withdrawalAmount, 15) : "");
                configs.append("inputInfo.customerBankId", this.selectedBank.customerBankId ? this.selectedBank.customerBankId : "");
                this.$service
                    .getService(this.SERVICE_NAME)
                    .withdrawalConfirm(configs)
                    .then((result) => {
                        // check verify masking status
                        if (result.errorMsgForVerify) {
                          this.init();
                          this.withdrawalAmount = null;
                          return;
                        } else {
                            if (result.errorMessage === "MSG_NAB022")
                                this.isWithdrawalAmountOverAvailableAmount = true;
                        }

                        this.message.successMessage = null;

                        if (result.errorMessage != null) {
                            this.model.errorMessage = result.errorMessage;
                        } else {
                            const input = result.inputInfo;
                            this.withdrawalFee = input.feeAmount;
                            this.withdrawalReceived = input.receivedAmount;
                            this.setMode(this.MODE_WITHDRAWAL_CONFIRM);
                        }
                        window.scrollTo(0, 0);
                    });
            }
        },
        backToInput() {
            this.model.errorMessage = null;
            this.model.successMessage = null;
            this.message.successMessage = null;
            this.init();
            this.setMode(this.MODE_WITHDRAWAL_INPUT);
        },
        confirmWithdrawal() {
            this.disableButtonConfirm = true;
            const configs = new FormData();
            configs.append("inputInfo.amount", this.withdrawalAmount);
            configs.append("inputInfo.customerBankId", this.selectedBank.customerBankId);
            this.$service.getService(this.SERVICE_NAME).submitWithdrawal(configs).then((result) => {
                // check verify masking status
                if (result.errorMsgForVerify || result.errorMessage) {
                  this.model.successMessage = null;
                  this.message.successMessage = null;
                  this.model.errorMessage = result.errorMessage;
                } else {
                  this.model.successMessage = result.successMessage;
                  this.message.successMessage = null;
                  this.withdrawalAmount = '';
                }

                this.isConfirmTransfer = false;
                this.currentPage = 1;
                this.getCurrentPageWithdrawalList();
                this.setMode(this.MODE_WITHDRAWAL_INPUT);

                window.scrollTo(0, 0);
                this.init();
            })
                .catch(() => {
                    this.model.successMessage = null;
                    this.message.successMessage = null;
                    this.message.errorMessage = null;
                    this.model.errorMessage = 'error.happen';
                    this.isConfirmTransfer = false;
                    this.currentPage = 1;
                    this.getCurrentPageWithdrawalList();
                    this.setMode(this.MODE_WITHDRAWAL_INPUT);
                }).finally(() => this.disableButtonConfirm = false);
        },
        cancelWithdrawal(wid) {
            this.wid = wid;
            this.model.errorMessage = null;
            this.model.successMessage = null;
            this.message.errorMessage = null;
            this.message.successMessage = null;
            const params = {
                messageText: "withdraw.cancel.request.confirm"
            };
            this.$modal.modalConfirm(params, this.IConstants.E_CONFIRM_SCREEN.WITHDRAWAL_CANCEL);
        },
        getModalConfirmResult() {
            ModalPlugin.EventBus.$on(this.IConstants.EVENT_NAME.CLOSE_MODAL_CONFIRM + this.IConstants.E_CONFIRM_SCREEN.WITHDRAWAL_CANCEL, (buttonClicked) => {
                if (buttonClicked && buttonClicked === "ok") {
                    const configs = new FormData();
                    configs.append("cancelInfo.withdrawalId", this.wid);
                    this.$service.getService(this.SERVICE_NAME).withdrawalCancel(configs).then((result) => {
                        if (result.errorMessage != null) {
                            this.model.errorMessage = result.errorMessage;
                        } else {
                            this.model.successMessage = result.successMessage;
                            this.message.successMessage = null;
                            this.init();
                        }
                      window.scrollTo(0, 0);
                    })
                        .catch((error) => {
                            if (error.errorMessage != null) {
                                this.model.errorMessage = error.errorMessage;
                            }
                            window.scrollTo(0, 0);
                        });
                }
            });
        },
        toConfirmScreen(){
            this.setMode(this.MODE_WITHDRAWAL_CONFIRM);
        },
        listenEvents() {
            ModalPlugin.EventBus.$on(IConstants.EVENT_NAME.MASKING_VERIFY_RESULT + IConstants.SCREEN_NAME.WITHDRAWAL, () => {
                this.init();
            });
            ModalPlugin.EventBus.$on(IConstants.EVENT_NAME.SHOW_PROFILE_MESSAGE, params => {
                if (params.message.successMessage) {
                    this.message.successMessage = params.message.successMessage;
                    this.message.errorMsgForVerify = null;
                    this.model.errorMessage = null;
                    this.model.successMessage = null;
                }
                if (params.message.verifyAuthenticatorFailMsg) {
                    this.message.errorMsgForVerify = params.message.verifyAuthenticatorFailMsg;
                    this.model.errorMessage = null;
                    this.message.successMessage = null;
                }
                if (params.callBackFunc) params.callBackFunc()
            });
        },
        unListenEvents() {
            ModalPlugin.EventBus.$off(IConstants.EVENT_NAME.MASKING_VERIFY_RESULT + IConstants.SCREEN_NAME.WITHDRAWAL);
            ModalPlugin.EventBus.$off(IConstants.EVENT_NAME.SHOW_PROFILE_MESSAGE);
        }
    },

};
</script>

<style scoped>
.row {
    margin-right: -20px;
    margin-left: -8px;
}

.dl-n {
    display: none;
}

.bank-list .row {
    margin-bottom: 0;
}

.visible-xs {
    display: none !important;
}

#moneyMask:disabled,
#moneyMask[disabled] {
    cursor: not-allowed;
    background-color: rgb(222, 226, 230) !important;
    border-color: #ccc !important;
}

@media (max-width: 767px) {
    .hidden-xs {
        display: none !important;
    }
}

@media (max-width: 767px) {
    .visible-xs {
        display: block !important;
    }
}

@media (max-width: 767px) {
    .bank-list .fix-flexbox {
        display: block;
    }
}

.datetime-column, .money-column {
    white-space: nowrap;
}

.btn-danger {
    padding-top: 1px;
    padding-bottom: 1px;
    width: 46px;
    height: 16px;
    font-size: 12px;
}

.margin-custom {
    margin-left: -15px;
}

@media screen and (max-width: 767px) {
    .tooltipbig-wrapper,.report-tooltip {
        margin-right: 23px;
    }
}

.warning-messages {
    color: #ff0000;
    background-color: #ffc0cb;
    display: inline-block;
    border-radius: 6px;
    padding: 14px;
    margin-left: -27px;
    margin-bottom: 10px;
}

@media screen and (max-width: 499px) {
    .warning-messages {
        width: 374px;
        margin-left: 6px;
    }
}

@media screen and (min-width: 500px) and (max-width: 767px) {
    .warning-messages {
        margin-left: 6px;
    }
}

@media screen and (max-width: 380px) {
    .warning-messages {
        width: 300px;
    }
}

@media screen and (min-width: 768px) and (max-width: 1180px) {
    .warning-messages {
        margin-left: 6px;
    }
}

@media screen and (max-width: 280px) {
    .warning-messages {
        width: 256px;
    }
}

@media screen and (min-width: 1180px) and (max-width: 1400px) {
    .warning-messages {
        margin-left: 22px;
    }
}

@media screen and (min-width: 1401px) {
    .warning-messages {
        margin-left: 0;
    }
}

.withdrawal-btn:disabled, .withdrawal-btn:disabled:hover, .withdrawal-execute-btn:disabled, .withdrawal-execute-btn:disabled:hover{
    background-color: rgb(222, 226, 230) !important;
    position: relative;
    border-color: #ccc !important;
    color: #aaa;
    opacity: unset !important;
}

#btn-add-bank, #btn-withdraw-confirm {
    white-space: nowrap;
}

.show-popup-help {
    display: inline-block;
    background-color: #ff9900;
    border: 3px solid #ff9900;
    padding: 7px;
    color: #ffffff;
    font-size: 12px;
    float: right;
    border-radius: 20px;
}
.show-popup-help:hover {
    background-color: #ffffff;
    border: 3px solid #ff9900;
    color: #ff9900;
}
</style>
